import { HEAT_STEPS, WEEKDAYS, formatNumber } from "../utils";

const HOUR_LABELS = [0, 6, 12, 18];

// 0 은 회색, 나머지는 최댓값 대비 5단계
function stepOf(value, max) {
    if (!value) {
        return 0;
    }
    return Math.min(HEAT_STEPS.length - 1, 1 + Math.floor((value / max) * (HEAT_STEPS.length - 1) * 0.999));
}

/**
 * 요일(월~일) × 시간(0~23) 방문 히트맵. heatmap[요일][시간] = 방문 수 (KST)
 */
export function FgHeatmap({ heatmap }) {
    const max = Math.max(...heatmap.flat(), 1);

    return (
        <div>
            <div className="grid grid-cols-[24px_repeat(24,minmax(0,1fr))] gap-[2px] min-[600px]:gap-[3px]">
                <span />
                {Array.from({ length: 24 }, (_, hour) => (
                    <span key={hour} className="whitespace-nowrap text-[10px] leading-4 text-gray-400">{HOUR_LABELS.includes(hour) ? `${hour}시` : ''}</span>
                ))}
                {heatmap.map((hours, dow) => (
                    <div key={dow} className="contents">
                        <span className="text-[11px] leading-[18px] text-gray-500 min-[600px]:leading-[22px]">{WEEKDAYS[dow]}</span>
                        {hours.map((value, hour) => (
                            <span
                                key={hour}
                                className="h-[18px] rounded-[3px] min-[600px]:h-[22px] min-[600px]:rounded-[4px]"
                                style={{ background: HEAT_STEPS[stepOf(value, max)] }}
                                title={`${WEEKDAYS[dow]}요일 ${hour}시 · 방문 ${formatNumber(value)}`}
                            />
                        ))}
                    </div>
                ))}
            </div>
            <div className="mt-3 flex items-center justify-end gap-1.5 text-[11px] text-gray-400" aria-hidden="true">
                적음
                {HEAT_STEPS.map(color => <span key={color} className="h-2.5 w-4 rounded-sm" style={{ background: color }} />)}
                많음
            </div>
        </div>
    );
}

/**
 * 방문이 가장 많은 요일·시간 (동률이면 앞선 칸)
 */
export function getPeakSlot(heatmap) {
    let peak = null;
    heatmap.forEach((hours, dow) => hours.forEach((value, hour) => {
        if (value && (!peak || value > peak.value)) {
            peak = { dow, hour, value };
        }
    }));
    return peak;
}
